import React from "react";
import { dateFormat } from "../helper";
import Button from "./ui/Button";
import ButtonGroup from "./ui/ButtonGroup";
import Field from "./ui/Field";
import Flatpickr from "./ui/Flatpickr";

const EtchForm = ({ state, setState, venueName, hotelCode, handleCheckInChange, handleCheckOutChange, handleOpen, today }) => {
  const handleGetAvailability = () => {
    // GA4
    if (state && 
      typeof window.dataLayer !== 'undefined'
    ) {
      window.dataLayer.push({
        check_in: state.checkIn,
        check_out: state.checkOut,
        venue_id: document.getElementById("youngs-dmn-booking").getAttribute('data-venue') || null,
        event: "room_enquiry",
        gtm_tag_name: `GA4 -  Book a room - Enquiry`
      });
    }
    // end GA4
  };
  return (
    <form action="https://www.youngshotels.co.uk/book/stay/guests" method="get" _lpchecked="1" target="_blank">
      {state.venues.length > 0 && (
        <Field label="Select a Venue" value={venueName}>
          <select
            name="hotelCode"
            onChange={(e) => {
              const { target: { value = "" } } = e || { target: {} };

              if (setState) {
                setState((previousState) => ({ ...previousState, venue: value }));
              }
            }}
            required
            value={state.venue || ""}
          >
            <option value="" aria-label="Select Option" />
            {state.venues.map((venue) => <option key={`venue-field-option-${venue.etchId || venue.guestLineId}`} value={venue.etchId || venue.guestLineId}>{venue.title}</option>)}
          </select>
        </Field>
      )}
      {!state.venues.length && <input type="hidden" name="hotelCode" id="hotelCode" value={hotelCode} />}
      <Field label="Check In" value={state.checkIn ? dateFormat(state.checkIn) : 'Select Date'}>
        <Flatpickr defaultDate={state.checkIn} handleChange={handleCheckInChange} handleOpen={handleOpen} minDate={today}>
          <input name="checkin" type="text" />
        </Flatpickr>
      </Field>
      <Field label="Check Out" value={state.checkOut ? dateFormat(state.checkOut) : 'Select Date'}>
        <Flatpickr defaultDate={state.checkOut} handleChange={handleCheckOutChange} handleOpen={handleOpen} minDate={today}>
          <input name="checkout" type="text" />
        </Flatpickr>
      </Field>
      <ButtonGroup>
        <Button 
          active
          onClick={handleGetAvailability}
        >
          Check Availability
        </Button>
      </ButtonGroup>
    </form>
  )
}

export default EtchForm;